import { SminexClubSearchClientPayload, SminexClubSearchPayload } from './subscription';
import { SminexClubSearchClient } from './types';

const mapProjects = (projects: SminexClubSearchClientPayload['projects']) => {
  if (!Array.isArray(projects)) return [];

  return projects.filter((code): code is string => typeof code === 'string' && !!code.trim());
};

export interface SminexClubSearchMappedPage {
  clients: SminexClubSearchClient[];
  receivedCount: number;
}

export const mapSminexClubSearchPayload = (payload?: SminexClubSearchPayload): SminexClubSearchMappedPage | null => {
  const rows = payload?.usersUpdates?.clients;

  if (!Array.isArray(rows)) return null;

  const clients: SminexClubSearchClient[] = [];

  rows.forEach((row) => {
    if (!row?.id) return;

    clients.push({
      crmUuid: row.id,
      firstName: row.firstName ?? '',
      lastName: row.lastName ?? '',
      surname: row.surname ?? null,
      manager: row.manager ?? null,
      broker: row.broker ?? null,
      callRefusal: row.callRefusal ?? null,
      projects: mapProjects(row.projects),
    });
  });

  return { clients, receivedCount: rows.length };
};
